var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1943 2.70759L5.01847 9.23196L1.81105 5.77242C1.71328 5.66653 1.59648 5.58239 1.46752 5.52494C1.33856 5.46749 1.20003 5.4379 1.0601 5.4379C0.920166 5.4379 0.781644 5.46749 0.65268 5.52494C0.523717 5.58239 0.406914 5.66653 0.309143 5.77242C0.110436 5.98939 -0.000671387 6.27962 -0.000671387 6.5817C-0.000671387 6.88378 0.110436 7.17401 0.309143 7.39099L4.26752 11.6589C4.36505 11.7653 4.48178 11.8498 4.61077 11.9075C4.73977 11.9652 4.87841 11.995 5.01847 11.995C5.15854 11.995 5.29718 11.9652 5.42617 11.9075C5.55517 11.8498 5.6719 11.7653 5.76943 11.6589L13.6895 4.32617C13.8882 4.10919 13.9993 3.81896 13.9993 3.51688C13.9993 3.2148 13.8882 2.92457 13.6895 2.70759C13.5922 2.60082 13.4756 2.5159 13.3465 2.4579C13.2175 2.39989 13.0788 2.37 12.9386 2.37C12.7984 2.37 12.6596 2.39989 12.5306 2.4579C12.4015 2.5159 12.2849 2.60082 12.1876 2.70759H12.1943Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/Icon-check.61a89e7c.svg";
export { ForwardRef as ReactComponent };